module.exports = __webpack_public_path__ + "static/img/quantijingyin.9b3c9b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/quantijingyin.png
// module id = CV7X
// module chunks = 24